/**
 * @description
 * Рендерим дату отзыва в красивом формате
 */

export default (date) => {
  const dateOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  };

  return new Date(date).toLocaleString('default', dateOptions);
};

